import { Page } from "../types";

interface Props {
  page: Page;
  setPage: (p: Page) => void;
}

const TABS: { id: Page; label: string; icon: string }[] = [
  { id: "today", label: "Today", icon: "⚾" },
  { id: "history", label: "History", icon: "📋" },
  { id: "about", label: "Model", icon: "📊" },
];

export default function BottomNav({ page, setPage }: Props) {
  return (
    <nav
      style={{
        position: "fixed",
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        width: "100%",
        maxWidth: 430,
        background: "#fff",
        borderTop: "1px solid #E4EAF8",
        display: "flex",
        zIndex: 50,
      }}
    >
      {TABS.map((t) => {
        const active = page === t.id;
        return (
          <button
            key={t.id}
            onClick={() => setPage(t.id)}
            style={{
              flex: 1,
              padding: "10px 0 12px",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 3,
            }}
          >
            <span
              style={{
                fontSize: "1.2rem",
                opacity: active ? 1 : 0.35,
                transition: "opacity 0.15s",
              }}
            >
              {t.icon}
            </span>
            <span
              style={{
                fontSize: "0.65rem",
                fontWeight: 700,
                letterSpacing: 0.5,
                color: active ? "#D42B2B" : "#8090B0",
                transition: "color 0.15s",
              }}
            >
              {t.label}
            </span>
            {active && (
              <div
                style={{
                  position: "absolute",
                  bottom: 0,
                  width: 24,
                  height: 2,
                  background: "#D42B2B",
                  borderRadius: 2,
                }}
              />
            )}
          </button>
        );
      })}
    </nav>
  );
}
